import React from 'react';
import { Link } from 'gatsby';
import { departmentNames } from '../constants';
import { germanUrlify } from '../helpers/helpers.js';
import Layout from '../components/layout';

const IndexPage = () => (
    <Layout>
        <ul>
            {departmentNames.map((departmentName) => (
                <li key={departmentName}>
                    <Link to={`/${germanUrlify(departmentName)}/`}>
                        {departmentName}
                    </Link>
                </li>
            ))}
        </ul>
    </Layout>
);

export default IndexPage;
